import { render } from "./Menu.vue?vue&type=template&id=5d72f938"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "vue-scroll-picker/lib/style.css?vue&type=style&index=0&lang=css"
import "./Menu.vue?vue&type=style&index=1&id=5d72f938&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__